/**
 * 生成数据存储器
 * 专供生成使用，为解析ai 提示词提供数据以及内置方法
 */
import { derive } from 'derive-zustand';
import {
  CoreEntityMap,
  CoreEntityType,
  NovelActSchema,
  NovelChapterSchema,
  NovelSceneSchema,
  NovelActTree,
  PromptType,
  CodexEntryGroup,
} from '#/index'
import { useNovelCoreStore } from './novelCoreStore';
import { useStore } from 'zustand';
import { getCodexEntryGroups, getNovelActsTree } from '@/utils';




// 包装小说数据
export type GenerateStore = {
  novelActsTree: NovelActTree[],
  novelActs: NovelActSchema[],
  novelChapters: NovelChapterSchema[],
  novelScenes: NovelSceneSchema[],
  codexEntries: CoreEntityMap<CoreEntityType.CodexEntries>[],
  codexCategories: CoreEntityMap<CoreEntityType.CodexCategories>[],
  codexFields: CoreEntityMap<CoreEntityType.CodexFields>[],
  novelSeries: CoreEntityMap<CoreEntityType.NovelSeries>[],
  prompts: CoreEntityMap<CoreEntityType.Prompts>[],
  snippets: CoreEntityMap<CoreEntityType.Snippets>[],
  novel?: CoreEntityMap<CoreEntityType.Novels>,
  codexEntryGroups: CodexEntryGroup[],
  getPromptComponent: (promptName: string) => CoreEntityMap<CoreEntityType.Prompts> | undefined,
}

export const generateStore = derive<GenerateStore>((get) => {
  const {
    novelActs,
    novelChapters,
    novelScenes,
    currentNovelId,
    codexEntries,
    codexCategories,
    codexFields,
    novelSeries,
    prompts,
    snippets,
    novels,
  } = get(useNovelCoreStore);

  let novelActsTree: NovelActTree[] = getNovelActsTree(currentNovelId, novelActs, novelChapters, novelScenes);
  const codexEntryGroups = getCodexEntryGroups(codexEntries, codexCategories)

  return {
    novelActsTree,
    novelActs,
    novelChapters,
    novelScenes,
    codexEntries,
    codexCategories,
    codexFields,
    novelSeries,
    prompts,
    codexEntryGroups,
    snippets,
    novel: novels.find(novel => novel.id === currentNovelId),
    getPromptComponent: (promptName: string) => {
      return prompts.find(prompt => prompt.attributes.type === PromptType.Component && prompt.attributes.name === promptName);
    },
  }
})

const useGenerateStore = () => {
  return useStore(generateStore);
}

export default useGenerateStore